"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Alert = ({ children }) => {
    return jsx_runtime_1.jsx("div", { children: children }, void 0);
};
exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map